import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DetailsService } from 'src/app/services/details.service';
import { RecipientService } from 'src/app/services/recipient.service';
import { SharerService } from 'src/app/services/sharer.service';
import { TaskService } from 'src/app/services/task.service';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { UpsiMasterService } from 'src/app/services/upsi-master.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import { UpsiParamService } from 'src/app/services/upsi-param.service';
import { UpsiDetailsService } from 'src/app/services/upsi-details.service';
import { UserMasterService } from 'src/app/services/user-master.service';
import { SharerUserListComponent } from '../sharer-user-list/sharer-user-list.component';
import { RecipientUserListComponent } from '../recipient-user-list/recipient-user-list.component';
import { AddSharerModalComponent } from '../add-sharer-modal/add-sharer-modal.component';
import { AddRecipientModalComponent } from '../add-recipient-modal/add-recipient-modal.component';
import { AlertComponent } from '../../alert/alert.component';
import { LoaderService } from 'src/app/services/loader.service';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { UPSISubscriptionService } from 'src/app/services/upsi-subscription.service';

declare var $: any;
declare var jQuery: any;
@Component({
  selector: 'app-add-upsi-details',
  templateUrl: './add-upsi-details.component.html',
  styleUrls: ['./add-upsi-details.component.css'],
 
})
export class AddUpsiDetailsComponent implements OnInit {
  @ViewChild('attachments') attachment: any;
  fileList: File[] = [];
  listOfFiles: any[] = [];
  fileNameArray: any[] = [];
  basefileArray: any[] = [];      //To store the actual files uplaoded by user
  basefileArrayUpdate: any[] = [];      //To store the actual files uplaoded by user in update screen
  basefileNameArray: any[] = [];  //To store the names of the files uploaded by user to be used in frontend
  fileDocArray: any[] = [];
  DocumentEmailArray: any[] = [];
  DocumentFileArray: any[] = [];
  combineArray: any[] = [];
  combineDocArray: any[] = [];
  sharerdateForPublic: NgbDateStruct;
  sharerForm: FormGroup;
  loading: boolean = false;
  fileSizeError: boolean;
  sharerName: string;
  newNonGovevaUser: any;
  sharerUserId: any;
  recipientIdArray: any;
  isEdit: boolean;
  formData: any;
  documentArr: any = [];
  FileNameOrignalDisplay: any = [];
  FileChangedName: any = [];
  filesToUpload: any;
  DocToUpload: any;
  listOfDoc: any[] = [];
  docList: any[] = [];
  isValidSharerAndRecipient: boolean = false;
  shareddate: any;
  upsidate: any;
  EnteredBy: any;
  entrydate: any;
  Updatedby: any;
  response: any;
  UPSIDetailsId: any;
  documentId: any;
  fileOriginalName: any;
  recipientList: any;
   // UPSI Subscription flags
   isUPSIMain: boolean = true; // Default to UPSI Main
   isUPSILite: boolean = false;
   upsiSubscriptionType: string = 'UPSI_MAIN';
  userlist: any;
  RecipientNameArray: any;
  downloadURLForUPSI: any = environment.pssServerUrl + "documentManagement/downloadSingleFileOnID/";
  downloadURLForUPSIEmail: any = environment.pssServerUrl + "upsi/EmailDoc/";
  downloadURLForUPSIBase: any = environment.pssServerUrl + "upsi/BaseDoc/";
  isFileDeleted: boolean = false;
  DocumentFileDoc: any;
  DocumentEmailDoc: any;
  isFileDeletedEmail: any;
  filesToUploadEmail: any;
  FileNameO: any;
  SharedIdView: any;
  ItemList: any;
  disabledText: boolean;
  item: any;
  disableShareDT: boolean;
  paramData: any;
  textMsg: boolean;
  othernature: boolean;
  OtherNatureOfUPSI: any;
  OtherNatureOfUPSIValid: any;
  public token: any = localStorage.getItem('token')
  public ipLocalPc: any;
  disabledOnclick: boolean = false;
  fileExtension: boolean = true;
  checkfileExtension: boolean = true;
  EmailWithAttachment: boolean;
  EmailUpsiAdd: boolean;
  isBulkData:boolean;
  todayDate: any;
  constructor(private upsiParamService: UpsiParamService, private loaderService:LoaderService, private taskService: TaskService, private upsiMasterService: UpsiMasterService,
    private sharerService: SharerService, private detailsService: DetailsService, private activatedRoute: ActivatedRoute, public modalService: NgbModal, private userMasterService: UserMasterService, 
    private upsiDatailsService: UpsiDetailsService, private alert: AlertComponent, private router: Router, public commonFunction: CommonFunction, private recipientService: RecipientService,
    private customValidation: CustomValidation, private upsiSubscriptionService: UPSISubscriptionService) { }

    ngOnDestroy(): void {
      // Re-enable loader when navigating away from this component
      this.loaderService.enable();
    }

  ngOnInit(): void {
    this.loaderService.disable();
    let currentUrl = this.router.url.substring(this.router.url.indexOf('/'), this.router.url.lastIndexOf('/'))
    this.isBulkData = currentUrl.includes('bulkData');

    var today = new Date;
    this.todayDate = {year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate()};
    this.upsiParamService.getOption().subscribe((response) => {

      if (response.status == 0) {
        var optionArray = response.data;

        var optionArrayEmail = optionArray.find(optionelement => {
          return (optionelement['paramOption'] == 'EmailWithAttachment')
        })
        var optionArrayEmailSend = optionArray.find(optionelement => {
          return (optionelement['paramOption'] == 'EmailUpsiAdd')
        })
        this.EmailWithAttachment = optionArrayEmail.paramValue;
        this.EmailUpsiAdd = optionArrayEmailSend.paramValue;
      }


    })


    // this.sharerService.getClientIp().subscribe((response) => {
    //   console.log('responseresponseresponse', (response))
    //   var ip = response.ip;
    //   this.ipLocalPc = ip
    // });



    this.newNonGovevaUser = false;
    this.fileSizeError = false;
    this.OtherNatureOfUPSIValid = true;
    this.sharerForm = new FormGroup({
      sharerType: new FormControl('', [Validators.required]),
      receipientType: new FormControl('', [Validators.required]),
      typeOfShared: new FormControl('', [
        Validators.required,
        Validators.maxLength(500),
        this.customValidation.inappropriateLanguageValidator.bind(this.customValidation)
      ]),
      purposeForSharing: new FormControl('', [
        Validators.required,
        Validators.maxLength(500),
        this.customValidation.inappropriateLanguageValidator.bind(this.customValidation)
      ]),
      sharedDate: new FormControl('', [Validators.required]),
      sharedTime: new FormControl('', [Validators.required]),
      publicDate: new FormControl('', null),
      publicTime: new FormControl('', null),
      possessionOfUPSI: new FormControl('', [Validators.maxLength(500)]),
      modeOfSharing: new FormControl('', [
        Validators.required,
        Validators.maxLength(500),
        this.customValidation.inappropriateLanguageValidator.bind(this.customValidation)
      ]),
      DateOfInitiation: new FormControl('', null),
      EmailText: new FormControl('', [Validators.maxLength(1000)]),
      EmailSubject: new FormControl('', [Validators.maxLength(250)]),
      NatureofUPSI: new FormControl('', [Validators.required]),
      OtherNatureOfUPSI: new FormControl('', [Validators.maxLength(100)]),
      PublicStatus: new FormControl('', null)
    })
    this.sharerForm.controls.publicTime.setValue(null);
    this.sharerForm.controls.publicDate.setValue(null);
    this.sharerForm.controls.DateOfInitiation.setValue(null);
    this.sharerForm.controls.sharerType.setValue('govevaUser');
    var userLogin = JSON.parse(localStorage.getItem("user"));
    this.SharedIdView = userLogin._id
    this.userMasterService.getUserByUserId(this.SharedIdView).then(userDetailsResponse => {
      if (!userDetailsResponse.status) {
        this.sharerUserId = this.SharedIdView
        this.sharerName = userDetailsResponse.userDetails.Title + " " + userDetailsResponse.userDetails.FirstName + " " + userDetailsResponse.userDetails.LastName
        this.newNonGovevaUser = false
      }
    })
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    this.paramData = {
      companyID: companyDetails.companyID
    }

    this.viewtagList(this.paramData);

    var timepicker_init_config = {
      widgetPositioning: {
        horizontal: 'left'
      },
      icons: {
        time: "fa fa-clock-o",
        date: "fa fa-calendar",
        up: "fa fa-arrow-up",
        down: "fa fa-arrow-down",
        previous: 'fa fa-arrow-left',
        next: 'fa fa-arrow-right'
      },
      format: 'hh:mm a'
    }
    $(function () {
      $('.timepicker-init').datetimepicker(timepicker_init_config);
    })
    $(function () {
      $('.timepicker-init-public').datetimepicker({
        widgetPositioning: {
          horizontal: 'left'
        },
        icons: {
          time: "fa fa-clock-o",
          date: "fa fa-calendar",
          up: "fa fa-arrow-up",
          down: "fa fa-arrow-down",
          previous: 'fa fa-arrow-left',
          next: 'fa fa-arrow-right'
        },
        format: 'hh:mm a',

      });
    })

    let recipientList = this.sharerService.getRecipientList({});
    let usersList = this.userMasterService.getAllUserList();
    Observable.forkJoin([recipientList, usersList])
      .subscribe((response:any) => {

        var recipientData;
        if (response[0].status == 0) {
          recipientData = response[0].data;
          this.recipientList = recipientData;
        } else {
          recipientData = {};
        }

        var usersData;
        if (response[1].status == 0) {
          usersData = response[1].result;
          this.userlist = usersData
        } else {
          usersData = {};
        }
        this.activatedRoute.params.subscribe(params => {
          if (params['detailsId']) {
            let fetchService = !this.isBulkData ? this.detailsService.editDetails : this.upsiDatailsService.getUpsiBulkDataById            
            fetchService = fetchService.bind(!this.isBulkData ? this.detailsService : this.upsiDatailsService)
            fetchService(params['detailsId']).subscribe(detailsData => {

              if(this.isBulkData){
                detailsData.data[0] = detailsData.data
              }
              this.UPSIDetailsId = params['detailsId']
              this.isEdit = true;
              this.sharerUserId = detailsData.data[0].SharerId
              this.recipientIdArray = detailsData.data[0].Recipients
              this.documentId = detailsData.data[0].DocumentId
              
              // Helper function to parse dates in DD/MM/YYYY format from backend
              const parseDDMMYYYY = (dateStr: any) => {
                if (!dateStr || dateStr === 0) return null;
                
                // If it's a number (timestamp), convert to date
                // Reject 0 or negative timestamps (invalid/not set)
                if (typeof dateStr === 'number') {
                  if (dateStr <= 0) return null;
                  const date = new Date(dateStr);
                  if (!isNaN(date.getTime())) {
                    return {
                      year: date.getUTCFullYear(),
                      day: date.getUTCDate(),
                      month: date.getUTCMonth() + 1
                    };
                  }
                  return null;
                }
                
                // If it's a string, try to parse DD/MM/YYYY format
                if (typeof dateStr === 'string') {
                  const parts = dateStr.split('/');
                  if (parts.length === 3) {
                    const day = parseInt(parts[0], 10);
                    const month = parseInt(parts[1], 10);
                    const year = parseInt(parts[2], 10);
                    
                    // Reject dates before 1970 (likely indicates 0 timestamp converted to date)
                    if (!isNaN(day) && !isNaN(month) && !isNaN(year) && year >= 1970) {
                      return { year: year, month: month, day: day };
                    }
                  }
                  
                  // Fallback: try standard Date parsing
                  const date = new Date(dateStr);
                  if (!isNaN(date.getTime()) && date.getFullYear() >= 1970) {
                    return {
                      year: date.getUTCFullYear(),
                      day: date.getUTCDate(),
                      month: date.getUTCMonth() + 1
                    };
                  }
                }
                
                return null;
              };
              
              // Fix date parsing with proper DD/MM/YYYY format handling
              var sharedDateObject = parseDDMMYYYY(detailsData.data[0].SharedDate);
              var publicDateObject = parseDDMMYYYY(detailsData.data[0].PublicDate);
              var DateOfInitiationObj = parseDDMMYYYY(detailsData.data[0].DateOfInitiation);
              
              $('.IsDisableEmail').prop("disabled", true);
              console.log('detailsData', detailsData.data[0].typeOfShared)
              this.sharerForm.controls.typeOfShared.setValue(detailsData.data[0].TypeOfShared);
              this.sharerForm.controls.purposeForSharing.setValue(detailsData.data[0].purposeForSharing)
              this.sharerForm.controls.sharerType.setValue(detailsData.data[0].SharerType === ""? "govevaUser" : detailsData.data[0].SharerType);
              this.sharerForm.controls.receipientType.setValue(detailsData.data[0].RecipientType);
              this.sharerForm.controls.sharedDate.setValue(sharedDateObject);
              this.sharerForm.controls.sharedTime.setValue(detailsData.data[0].SharedTime);
              this.sharerForm.controls.publicDate.setValue(publicDateObject);
              this.sharerForm.controls.publicTime.setValue(detailsData.data[0].PublicTime);
              this.sharerForm.controls.possessionOfUPSI.setValue(detailsData.data[0].possessionOfUPSI);
              this.sharerForm.controls.modeOfSharing.setValue(detailsData.data[0].modeOfSharing);
              this.sharerForm.controls.DateOfInitiation.setValue(DateOfInitiationObj);
              this.sharerForm.controls.EmailText.setValue(detailsData.data[0].EmailText);
              this.sharerForm.controls.EmailSubject.setValue(detailsData.data[0].EmailSubject);
              this.sharerForm.controls.PublicStatus.setValue(detailsData.data[0].PublicStatus);
              if (!detailsData.data[0].NatureofUPSI || detailsData.data[0].NatureofUPSI == null) {
                this.sharerForm.controls.NatureofUPSI.setValue('Other');
              } else {
                this.sharerForm.controls.NatureofUPSI.setValue(detailsData.data[0].NatureofUPSI);
              }
              
              // Fix sharerdateForPublic with proper DD/MM/YYYY format handling
              this.sharerdateForPublic = parseDDMMYYYY(detailsData.data[0].SharedDate);



              this.sharerForm.controls.OtherNatureOfUPSI.setValue(detailsData.data[0].OtherNatureOfUPSI);
              this.fileOriginalName = detailsData.data[0].FileOriginalName;
              this.basefileNameArray = []
              if(this.fileOriginalName){
                for(var x=0;x<this.fileOriginalName.length;x++){
                  var file = { name : this.commonFunction.returnFilenameAfterfirstHypen(this.fileOriginalName[x]), backendName : this.fileOriginalName[x] }
                  this.basefileNameArray.push(file);
                }
              }
              this.DocumentFileDoc = detailsData.data[0].FileNameUqEmail;
              this.DocumentFileArray = this.DocumentFileDoc;
              this.DocumentFileArray = this.DocumentFileArray.filter(function (e) {return e != "";});

              try{
                this.fileDocArray = detailsData.data[0].FileOriginalName.split(',')
                //this.fileNameArray = this.fileNameArray.filter(function (e) {return e != "";});
              }catch{
                this.fileDocArray =  (detailsData.data[0].FileOriginalName) ? detailsData.data[0].FileOriginalName.slice(detailsData.data[0].FileOriginalName.indexOf("-") + 1) : ""
              }
              

              this.DocumentEmailDoc = detailsData.data[0].FileNameUqEmail;
              this.DocumentEmailArray = this.DocumentEmailDoc
              this.DocumentEmailArray = this.DocumentEmailArray.filter(function (e) {return e != "";});

              try{
                this.fileNameArray = detailsData.data[0].FileNameUqEmail.split(',')
                //this.fileNameArray = this.fileNameArray.filter(function (e) {return e != "";});
              }catch{
                this.fileNameArray =  (detailsData.data[0].FileNameUqEmail) ? detailsData.data[0].FileNameUqEmail.slice(detailsData.data[0].FileNameUqEmail.indexOf("-") + 1) : ""
              }

              //this.FileNameO = (detailsData.data[0].FileNameUqEmail) ? detailsData.data[0].FileNameUqEmail.slice(detailsData.data[0].FileNameUqEmail.indexOf("-") + 1) : ""


              if (detailsData.data[0].SharerType == 'nonGovevaUser') {
                this.sharerService.editSharer(this.sharerUserId).subscribe(sharerDATA => {
                  this.sharerName = sharerDATA.data[0].Name
                })
              } else {
                this.userMasterService.getUserByUserId(this.sharerUserId).then(userDetailsResponse => {
                  if (!userDetailsResponse.status) {
                    this.sharerName = userDetailsResponse.userDetails.Title + " " + userDetailsResponse.userDetails.FirstName + " " + userDetailsResponse.userDetails.LastName
                    this.newNonGovevaUser = false
                  }
                })
              }
              
              // Properly populate RecipientNameArray with full recipient objects
              if (this.recipientIdArray && this.recipientIdArray.length > 0) {
                this.RecipientNameArray = this.recipientIdArray;
                
                // If recipients are goveva users, fetch their details
                if (detailsData.data[0].RecipientType === 'govevaUser') {
                  const selectedRecipients: any[] = [];
                  this.recipientIdArray.forEach((recip: any) => {
                    const recipId = recip._id || recip;
                    const userMatch = (this.userlist || []).find((u: any) => u._id == recipId);
                    if (userMatch) {
                      selectedRecipients.push({
                        _id: recipId,
                        UserType: 'govevaUser',
                        Name: `${userMatch.Title || ''} ${userMatch.FirstName || ''} ${userMatch.LastName || ''}`.trim()
                      });
                    } else {
                      selectedRecipients.push(recip);
                    }
                  });
                  this.RecipientNameArray = selectedRecipients;
                } else if (detailsData.data[0].RecipientType === 'nonGovevaUser') {
                  // For non-goveva recipients, they should already have Name property from backend
                  this.RecipientNameArray = this.recipientIdArray;
                }
              } else {
                this.RecipientNameArray = [];
              }


              this.EmailsCheckOniN();
              this.changeNature()
              this.othernaturemethod()

              // Mark all form controls as touched to trigger validation
              Object.keys(this.sharerForm.controls).forEach(key => {
                this.sharerForm.get(key).markAsTouched();
                this.sharerForm.get(key).updateValueAndValidity();
              });


            })
          }
        });
      });


    // Fetch UPSI subscription type for the logged-in company
    this.fetchUPSISubscriptionType();
  }
   /**
   * Fetch UPSI Subscription Type for the current company
   */
   fetchUPSISubscriptionType() {
    try {
      let companyDetails = JSON.parse(localStorage.getItem('companyDetailsGoveva'));
      if (companyDetails && companyDetails.value) {
        this.upsiSubscriptionService.getUPSISubscriptionConfig(companyDetails.value)
          .then((response: any) => {
            if (response && response.status === 0 && response.data) {
              this.upsiSubscriptionType = response.data.SubscriptionType || 'UPSI_MAIN';
              this.isUPSIMain = response.data.IsUPSIMain !== undefined ? response.data.IsUPSIMain : true;
              this.isUPSILite = response.data.IsUPSILite !== undefined ? response.data.IsUPSILite : false;
              
              // Store in localStorage for use across the app
              localStorage.setItem('upsiSubscriptionType', this.upsiSubscriptionType);
              localStorage.setItem('isUPSIMain', this.isUPSIMain.toString());
              localStorage.setItem('isUPSILite', this.isUPSILite.toString());
              
              console.log('UPSI Subscription Type:', this.upsiSubscriptionType);
              console.log('Is UPSI Main:', this.isUPSIMain);
              console.log('Is UPSI Lite:', this.isUPSILite);
            } else {
              // Default to UPSI Main if no config found
              this.upsiSubscriptionType = 'UPSI_MAIN';
              this.isUPSIMain = true;
              this.isUPSILite = false;
              localStorage.setItem('upsiSubscriptionType', 'UPSI_MAIN');
              localStorage.setItem('isUPSIMain', 'true');
              localStorage.setItem('isUPSILite', 'false');
            }
          })
          .catch(error => {
            console.error('Error fetching UPSI subscription type:', error);
            // Default to UPSI Main on error
            this.isUPSIMain = true;
            this.isUPSILite = false;
            this.upsiSubscriptionType = 'UPSI_MAIN';
            localStorage.setItem('upsiSubscriptionType', 'UPSI_MAIN');
            localStorage.setItem('isUPSIMain', 'true');
            localStorage.setItem('isUPSILite', 'false');
          });
      } else {
        // No company details, set defaults
        this.upsiSubscriptionType = 'UPSI_MAIN';
        this.isUPSIMain = true;
        this.isUPSILite = false;
        localStorage.setItem('upsiSubscriptionType', 'UPSI_MAIN');
        localStorage.setItem('isUPSIMain', 'true');
        localStorage.setItem('isUPSILite', 'false');
      }
    } catch (error) {
      console.error('Error in fetchUPSISubscriptionType:', error);
      // Default to UPSI Main on error
      this.isUPSIMain = true;
      this.isUPSILite = false;
      this.upsiSubscriptionType = 'UPSI_MAIN';
      localStorage.setItem('upsiSubscriptionType', 'UPSI_MAIN');
      localStorage.setItem('isUPSIMain', 'true');
      localStorage.setItem('isUPSILite', 'false');
    }
  }
  /**
   * Check if UPSI Lite subscription is active
   * Returns true if the company has UPSI Lite subscription
   */
  get isUPSILiteActive(): boolean {
    const isLite = localStorage.getItem('isUPSILite');
    return isLite === 'true';
  }
  

  initiateUploadEmailDocument($event) {
    // console.log(data);
    
    // $("#documentUploadLable").html("Upload Notice Doc.");
    $("#UpsiUploadTitle").html("Attachment For Emails");
    $("#upsiDetailsUploadDialog").modal('toggle');
  }
  initiateUploadFileBase($event) {
    // console.log(data);
    
    // $("#documentUploadLable").html("Upload Notice Doc.");
    $("#BaseUpsiUploadTitle").html("Attachment For Document");
    $("#BaseUpsiDetailsUploadDialog").modal('toggle');
  }
  onDocumentFileChanged(event:any){
    var date = new Date();
    var timestamp = date.getTime();
    for (var i = 0; i <= event.target.files.length - 1; i++) {
      this.DocToUpload = event.target.files[i];
      let fileObj = {
        target: {
          files: [this.DocToUpload]
        }
      }
      if(this.commonFunction.checkFileExtension(fileObj)){
        this.docList.push(this.DocToUpload);
        this.listOfDoc.push(this.DocToUpload.name)
      } else {
        this.alert.error("Invalid file extension")
      }
    }
    this.attachment.nativeElement.value = '';
  }
  onEmailFileChanged(event: any) {
    
    var date = new Date();
    var timestamp = date.getTime();
    if (this.fileList.length + event.target.files.length <= 10) {
      for (var i = 0; i <= event.target.files.length - 1; i++) {
        this.filesToUpload = event.target.files[i];
        let fileObj = {
          target: {
            files: [this.filesToUpload]
          }
        }
        if(this.commonFunction.checkFileExtension(fileObj)){
          var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileObj,event)
          if(filenameValidation == "Valid"){
            this.fileList.push(this.filesToUpload);
            this.listOfFiles.push(this.filesToUpload.name)
          } else {
            this.alert.error(filenameValidation);
          }
        } else {
          this.alert.error("Invalid file extension")
        }
      }
    } else {
      this.alert.error("Number of files cannot be more than 10");
    }
    this.attachment.nativeElement.value = '';
    
  } 


  onEmailFileChangedBase(event: any) {
    
    if (this.fileList.length + event.target.files.length <= 10) {
      for (var i = 0; i <= event.target.files.length - 1; i++) {
        var basefilesToUpload = event.target.files[i];
        let fileObj = {
          target: {
            files: [basefilesToUpload]
          }
        }
        if(this.commonFunction.checkFileExtension(fileObj)){

          var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect(fileObj,event);
	        if(filenameValidation == "Valid"){
            if(this.isEdit){ this.basefileArrayUpdate.push(basefilesToUpload); }
            else{ this.basefileArray.push(basefilesToUpload); }
            var nameFile = {name :  event.target.files[i].name, backendName : null}
            this.basefileNameArray.push(nameFile);

          }else{
            this.alert.error(filenameValidation);
          }
          
        } else {
          this.alert.error("Invalid file extension");
        }
      }
    } else {
      this.alert.error("Number of files cannot be more than 10");
    }

    this.attachment.nativeElement.value = '';
    
  } 

  removeSelectedEmailFile(index) {
    // Delete the item from fileNames list
    this.listOfFiles.splice(index, 1);
    // delete file from FileList
    this.fileList.splice(index, 1);
  }
  removeSelectedDocFile(index) {
    // Delete the item from fileNames list
    this.listOfDoc.splice(index, 1);
    // delete file from FileList
    this.docList.splice(index, 1);
  }

  userListModal($event) {
    console.log('checking whether it is true or false', $event.target.value)
    const modelRef = this.modalService.open(AddSharerModalComponent, {
      size: 'lg'
    })
    modelRef.componentInstance.ismodal = 1;
    modelRef.result.then(response => {
      this.alert.success(response.message)
    }, error => {

    })
  }

  recipientUserListModal($event) {
    const modelRef = this.modalService.open(AddRecipientModalComponent, {
      size: 'lg'
    })
    modelRef.componentInstance.ismodal = 1;
    modelRef.result.then(response => {
      this.alert.success(response.message)
    }, error => {

    })
  }

  // fileChanged($event) {
  //   this.checkfileExtension = true;
  //   console.log('file changed', $event.target.files[0])
  //   if ($event.target.files[0] / (1024 * 1024) > (1024 * 1024)) {
  //     this.fileSizeError = true;
  //   } else {
  //     this.fileSizeError = false;
  //     // this.formData = new FormData();
  //     // this.formData.append('files', $event.target.files[0])
  //     var checkfile = this.commonFunction.checkFileExtension($event);
  //     if (checkfile) {
  //       this.filesToUpload = $event.target.files[0];
  //       this.checkfileExtension = true;
  //     } else {
  //       this.checkfileExtension = false;
  //     }
  //   }
  // }

  sharerListModal(typeOfUser) {
    const modalRef = this.modalService.open(SharerUserListComponent, {
      size: 'lg'
    })
    modalRef.componentInstance.typeOfUserList = typeOfUser
    modalRef.componentInstance.sharerId = this.sharerUserId
    modalRef.result.then(userId => {
      console.log('userId', userId)
      this.sharerUserId = userId
      if (typeOfUser == 'nonGovevaUser') {
        this.sharerService.editSharer(this.sharerUserId).subscribe(sharerDATA => {
          this.sharerName = sharerDATA.data[0].Name
        })
      } else {
        this.userMasterService.getUserByUserId(userId).then(userDetailsResponse => {
          if (!userDetailsResponse.status) {
            this.sharerName = userDetailsResponse.userDetails.Title + " " + userDetailsResponse.userDetails.FirstName + " " + userDetailsResponse.userDetails.LastName
            this.newNonGovevaUser = false
          }
        })
      }
    }, (error) => {
          this.sharerUserId = this.SharedIdView
          this.sharerForm.controls.sharerType.setValue('govevaUser');
    })
  }

  recipientListModal(typeOfUser) {
    const modalRef = this.modalService.open(RecipientUserListComponent, {
      size: 'lg'
    })
    modalRef.componentInstance.typeOfUserList = typeOfUser
    modalRef.componentInstance.recipientArray = this.recipientIdArray
    modalRef.result.then(userIds => {
      // Persist selected ids from modal
      this.recipientIdArray = userIds;

      if (typeOfUser === 'nonGovevaUser') {
        // For non-goveva: fetch details from recipient service per id to ensure latest Name
        const selectedRecipients: any[] = [];
        const fetches = (this.recipientIdArray || []).map((sel: any) => {
          const selId = sel?._id || sel;
          return this.recipientService.editRecipient(selId).toPromise().then((res: any) => {
            if (res && res.data && res.data[0]) {
              selectedRecipients.push(res.data[0]);
            }
          }).catch(() => {});
        });
        Promise.all(fetches).then(() => {
          this.RecipientNameArray = selectedRecipients;
        });
      } else {
        // For goveva users: Use the user objects returned from modal directly (they already have Name property)
        // If modal returns full objects, use them; otherwise look up from userlist
        const selectedRecipients: any[] = [];
        (this.recipientIdArray || []).forEach((sel: any) => {
          // Check if sel already has Name property (returned as full object from modal)
          if (sel && sel.Name) {
            selectedRecipients.push({
              _id: sel._id || sel,
              UserType: 'govevaUser',
              Name: sel.Name
            });
          } else {
            // Otherwise, look up from userlist (which now includes unauthorized users)
            const selId = sel?._id || sel;
            const userMatch = (this.userlist || []).find((u: any) => u._id == selId);
            if (userMatch) {
              selectedRecipients.push({
                _id: selId,
                UserType: 'govevaUser',
                Name: `${userMatch.Title || ''} ${userMatch.FirstName || ''} ${userMatch.LastName || ''}`.trim()
              });
            } else {
              // Fallback: check recipient list
              const match = (this.recipientList || []).find((r: any) => r._id == selId);
              if (match) { 
                selectedRecipients.push(match); 
              }
            }
          }
        });
        this.RecipientNameArray = selectedRecipients;
      }

    });
  }

  timeShared($event) {

    var today = new Date;
    var am_pm = (today.getHours() >= 12) ? " pm" : " am"
    var current_time = today.getHours() + ":" + today.getMinutes() + am_pm;

    // Removed date/time restrictions - allow past, current, and future dates/times
    // Simply set the selected time without any validation
    this.sharerForm.controls.sharedTime.setValue($('.timepicker-init').val());


  }

  timePublic($event) {
    console.log($event)
    this.sharerForm.controls.publicTime.setValue($('.timepicker-init-public').val());
  }

  uplaodBaseUPSIFile(mainContext, fileArrayToUpload){
    var date = new Date();
    var timestamp = date.getTime();
    var baselistOfDoc = fileArrayToUpload.map(f =>{return `${timestamp}-${f.name}`});

  
    return new Promise(function (resolve,reject) {
      mainContext.makeFileRequestEmail(environment.pssServerUrl + "upsi/DetailsBaseAttachment/", timestamp, fileArrayToUpload, 'UPSI').then(
        function(response){

          console.error('response---------', response)
          if (response) {
            resolve(baselistOfDoc);
          }else{
            resolve([]);
          }
        }
      );
    });
  }
  

  async submit () {

    this.disabledOnclick = true;
    this.loading = true;
    var date = new Date();
    var timestamp = date.getTime();
    if (_.size(this.sharerUserId) && _.size(this.recipientIdArray)) {
      this.isValidSharerAndRecipient = false;
      let UPSIDetailObject = Object.assign({}, this.sharerForm.value);
      if (this.DocToUpload) {
        console.log("this.filesToUpload", this.DocToUpload);
        UPSIDetailObject.file = [];
        //this.filesToUpload.name;
        this.listOfDoc = this.listOfDoc.map(f =>{return `${timestamp}-${f}`});

        this.combineDocArray = this.listOfDoc.concat(this.fileDocArray);
        //var removeNullElementFromArray = this.combineDocArray.filter(function (e) {return e != null;});
        UPSIDetailObject.file.push(this.combineDocArray);
      }
      UPSIDetailObject.NatureText = $('#NatureId>option:selected').text()
      UPSIDetailObject.OtherNatureOfUPSI = this.OtherNatureOfUPSI;
      UPSIDetailObject.sharerId = this.sharerUserId;
      UPSIDetailObject.recipientUserIDs = this.recipientIdArray
      UPSIDetailObject.IPAddress = this.ipLocalPc
      if (_.size(this.sharerForm.value.EmailSubject) || _.size(this.sharerForm.value.EmailText) || (this.filesToUploadEmail && _.size(this.filesToUploadEmail.name))) {
        var sharerTime = new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        UPSIDetailObject.sharedTime = sharerTime;
      }

      UPSIDetailObject.sharedDate = this.sharerForm.value.sharedDate.month + '-' + this.sharerForm.value.sharedDate.day + '-' + this.sharerForm.value.sharedDate.year;
      UPSIDetailObject.publicDate = (_.size(this.sharerForm.value.publicDate)) ? this.sharerForm.value.publicDate.month + '-' + this.sharerForm.value.publicDate.day + '-' + this.sharerForm.value.publicDate.year : null;
      UPSIDetailObject.DateOfInitiation = (_.size(this.sharerForm.value.DateOfInitiation)) ? this.sharerForm.value.DateOfInitiation.month + '-' + this.sharerForm.value.DateOfInitiation.day + '-' + this.sharerForm.value.DateOfInitiation.year : null;
      UPSIDetailObject.FileNameUqEmail = [];
      //(this.filesToUploadEmail) ? timestamp + "-" + this.filesToUploadEmail.name.replace(',', '') : null
      this.listOfFiles = this.listOfFiles.map(f =>{return `${timestamp}-${f}`});

      this.combineArray = this.listOfFiles.concat(this.fileNameArray);
      var removeNullElementFromArray = this.combineArray.filter(function (e) {return e != null;});
      UPSIDetailObject.FileNameUqEmail.push(removeNullElementFromArray);
     
      // if (!this.filesToUploadEmail) {
      //   delete UPSIDetailObject.FileNameUqEmail;
      // }

      // if (this.isFileDeletedEmail) {
      //   UPSIDetailObject.FileNameUqEmail = null
      // }
      var self = this


      
      //Logic to process baseFiles(File not for email)----------------------------------------------------------------------------------------------
      if(this.basefileArray.length > 0){
        var baseFileUploaded = await this.uplaodBaseUPSIFile(this,this.basefileArray);
        UPSIDetailObject.FileOriginalName = baseFileUploaded;
      }
      //Logic to process baseFiles(File not for email) ENDS-----------------------------------------------------------------------------------------

      if (this.fileList) {
        this.makeFileRequestEmail(environment.pssServerUrl + "upsi/DetailsEmailAttachment/", timestamp, this.fileList, 'UPSI').then(function (responseData) {
          console.log('uuuuuuuuuuuuuuuuuuuuu', UPSIDetailObject)
          self.upsiDatailsService.addUPSI(UPSIDetailObject).subscribe((response:any) => {
            self.disabledOnclick = false;
            self.loading = false;
            if (!response.status) {
              // this.upsiDatailsService.uploadFile(response.result._id, this.formData).subscribe(fileUploadResponse => {
              //   console.log('fileUploadResponse', fileUploadResponse)
              // })
              if (self.DocToUpload) {
                self.makeFileRequest1(environment.pssServerUrl + "upsidetails/fileUpload/" + response.result._id, timestamp, self.docList, 'UPSI', null).then((result) => {
                  self.alert.successWithOk('UPSI Detail is added successfully.', 'userMaster/upsidetails')
                }, (error) => {
                  delete UPSIDetailObject.file;
                  // console.log("UPSIDetailObject*******************************************",response.result._id, UPSIDetailObject)
                  self.upsiDatailsService.updateUPSI(response.result._id, UPSIDetailObject).subscribe(response => {
                    console.log(response);
                  })
                  // this.alert.error(error);
                  self.disabledOnclick = false;
                  self.loading = false;
                  // this.alert.errorWithOk(error, 'upsidetails');
                  self.alert.successWithOk('UPSI Detail is added successfully.', 'userMaster/upsidetails')
                  return false;
                });
              } else {

                self.alert.successWithOk('UPSI Detail is added successfully.', 'userMaster/upsidetails')
              }
              // this.router.navigate(['upsidetails'])
            }
          })
        }, (error) => {
          console.error("***************Error in File upload****************", error);
          if(JSON.parse(error).error.code === "LIMIT_UNEXPECTED_FILE"){
            this.alert.error("Number of files cannot be more than 10")
          } else {
            this.alert.error(error);
          }
          this.fileList = []
          this.listOfFiles = []
          this.disabledOnclick = false;
          this.loading = false;
          return false;
        })
      } else {

        this.upsiDatailsService.addUPSI(UPSIDetailObject).subscribe((response:any) => {
          this.disabledOnclick = false;
          this.loading = false;
          if (!response.status) {
            console.log('Added success fully.')
            // this.upsiDatailsService.uploadFile(response.result._id, this.formData).subscribe(fileUploadResponse => {
            //   console.log('fileUploadResponse', fileUploadResponse)
            // })
            if (this.filesToUpload) {
              this.makeFileRequest1(environment.pssServerUrl + "upsidetails/fileUpload/" + response.result._id, [], [this.filesToUpload], 'UPSI', null).then((result) => {
                this.alert.successWithOk('UPSI Detail is added successfully.', 'userMaster/upsidetails')
              }, (error) => {
                console.error("***************Error in File upload****************", error);
                delete UPSIDetailObject.file;
                this.upsiDatailsService.updateUPSI(response.result._id, UPSIDetailObject).subscribe(response => {
                  console.log(response);
                })
                // this.alert.error(error);
                self.disabledOnclick = false;
                self.loading = false;
                // this.alert.errorWithOk(error, 'upsidetails');
                self.alert.successWithOk('UPSI Detail is added successfully.', 'userMaster/upsidetails')
                return false;
              });
            } else {
              this.alert.successWithOk('UPSI Detail is added successfully.', 'userMaster/upsidetails')
            }
            // this.router.navigate(['upsidetails'])
          } else {
            this.alert.error(JSON.stringify(response.err_fields) + ' fields are required or invalid.')
          }
        })

      }

    } else {
      this.isValidSharerAndRecipient = true;
    }
  }


  makeFileRequest1(url: string, params: any, files: Array<File>, title: string, meetingType: string) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var self = this;
      var xhr = new XMLHttpRequest();
      console.log('files', files)
      for (var i = 0; i < files.length; i++) {
        var newDate = Date.now();
        self.FileNameOrignalDisplay.push(files[i].name.replace(',', ''));
        formData.append("file", files[i], files[i].name.replace(',', ''));
        self.FileChangedName.push(files[i].name.replace(',', ''));
        console.log('this.FileChangedName', this.FileChangedName);
        console.log('this.FileorignalName', this.FileNameOrignalDisplay);

        var document = {
          "DocumentName": title + " - Agenda Document - " + i,
          "DateOfDocument": new Date(),
          "CompletedDate": null,
          "MeetingTypeID": meetingType,
          "ParentDocumentTypeID": null,
          "ParentSubDocumentTypeID": null,
          "DirectorKmp": "None",
          "DirectorID": null,
          "KMPID": null,
          "Remarks": "",
          "Overwrite": false,
          "Filename": files[i].name.replace(',', ''),
          "OriginalFileName": files[i].name.replace(',', ''),
          // "FilePath": "D:\\Harrier\\PSSProject\\pss_api\\uploads\\Document_Type\\",
          "CreatedBy": null,
          "CreatedDate": new Date(),
          "LastUpdateFiles": new Date(),
          "ModifiedBy": null,
          "ModifiedDate": null,
          "CompanyID": JSON.parse(localStorage.getItem("companyDetails")).companyID
        }
        self.documentArr.push(document);
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }


  back() {
    let route = !this.isBulkData ? 'upsidetails' : "upsibulkdata"
    this.router.navigate([{ outlets: { 'structure-outlet': ['userMaster', route] } }],
    { relativeTo: this.activatedRoute.parent })
  }

  async update() {

    this.disabledOnclick = true;
    this.loading = true;
    let self = this;
    var date = new Date();
    var timestamp = date.getTime();
    console.log('checking for sharer form', this.sharerForm)
    if (_.size(this.sharerUserId) && _.size(this.recipientIdArray)) {
      this.isValidSharerAndRecipient = false;
      let UPSIDetailObject = Object.assign({}, this.sharerForm.value)
      if (this.DocToUpload) {
        console.log("this.filesToUpload", this.DocToUpload);
        UPSIDetailObject.file = [];
        //this.filesToUpload.name;
        this.listOfDoc = this.listOfDoc.map(f =>{return `${timestamp}-${f}`});

        this.combineDocArray = this.listOfDoc.concat(this.fileDocArray);
        var removeNullElementFromArray = this.combineDocArray.filter(function (e) {return e != null;});
        UPSIDetailObject.file.push(removeNullElementFromArray);
      }
      UPSIDetailObject.NatureText = $('#NatureId>option:selected').text()
      UPSIDetailObject.OtherNatureOfUPSI = this.OtherNatureOfUPSI;
      UPSIDetailObject.sharerId = this.sharerUserId;
      UPSIDetailObject.recipientUserIDs = this.recipientIdArray
      UPSIDetailObject.IPAddress = this.ipLocalPc;
      UPSIDetailObject.sharedDate = this.sharerForm.value.sharedDate.month + '-' + this.sharerForm.value.sharedDate.day + '-' + this.sharerForm.value.sharedDate.year;
      UPSIDetailObject.publicDate = (_.size(this.sharerForm.value.publicDate)) ? this.sharerForm.value.publicDate.month + '-' + this.sharerForm.value.publicDate.day + '-' + this.sharerForm.value.publicDate.year : null;
      UPSIDetailObject.DateOfInitiation = (_.size(this.sharerForm.value.DateOfInitiation)) ? this.sharerForm.value.DateOfInitiation.month + '-' + this.sharerForm.value.DateOfInitiation.day + '-' + this.sharerForm.value.DateOfInitiation.year : null;
      UPSIDetailObject.FileNameUqEmail = [];

      this.listOfFiles = this.listOfFiles.map(f =>{return `${timestamp}-${f}`});

      this.combineArray = this.listOfFiles.concat(this.fileNameArray);
      var removeNullElementFromArray = this.combineArray.filter(function (e) {return e != null;});
      UPSIDetailObject.FileNameUqEmail.push(removeNullElementFromArray);
      console.log(this.combineArray);

      if(this.basefileArrayUpdate){
        var baseFileUploadedUpdate:any = await this.uplaodBaseUPSIFile(this,this.basefileArrayUpdate);
        var combinedBaseFile = this.basefileNameArray.map(file=> {if(file.backendName){return file.backendName}});
        combinedBaseFile = [...combinedBaseFile,...baseFileUploadedUpdate];
        combinedBaseFile = combinedBaseFile.filter(file => {return file});
        UPSIDetailObject.FileOriginalName = combinedBaseFile;
      }

      //Need to call a function => detectNewFilesandUplaodThem()

      //(this.filesToUploadEmail) ? timestamp + "-" + this.filesToUploadEmail.name.replace(',', '') : null
      // if (!this.filesToUploadEmail) {
      //   delete UPSIDetailObject.FileNameUqEmail;
      // }
      // console.log("this.filesToUploadEmail", this.filesToUploadEmail)
      // if (this.isFileDeletedEmail && (this.filesToUploadEmail == false || this.filesToUploadEmail == undefined)) {
      //   UPSIDetailObject.FileNameUqEmail = null
      // }
      console.log('UPSIDetailObject', UPSIDetailObject)
      if (this.isFileDeleted == true && this.filesToUpload == undefined) {
        this.upsiDatailsService.deleteFile(this.UPSIDetailsId).subscribe(response => {
          console.log('file is deleted!!!')
        })
      }
      let newFormData = new FormData();
      if (this.filesToUpload) {
        //newFormData.append('FileNameUqEmail', timestamp + "-" + this.filesToUploadEmail.name.replace(',', ''))
        this.makeFileRequestEmail(environment.pssServerUrl + "upsi/DetailsEmailAttachment/", timestamp,this.fileList, 'UPSI');
      }
      console.log('filesToUpload', this.filesToUpload)

      if (this.filesToUpload) {

        this.upsiDatailsService.updateUPSI(this.UPSIDetailsId, UPSIDetailObject).subscribe((response:any) => {
          this.disabledOnclick = false;
          this.loading = false;
          if (!response.status) {
            newFormData.append('FileNameUqEmail', UPSIDetailObject.FileNameUqEmail)
            newFormData.append('file', UPSIDetailObject.file)
            newFormData.append('publicDate', UPSIDetailObject.publicDate)
            newFormData.append('publicTime', UPSIDetailObject.publicTime)
            newFormData.append('sharerId', this.sharerUserId)
            newFormData.append('receipientType', UPSIDetailObject.receipientType)
            // newFormData.append('recipientUserIDs', JSON.stringify(UPSIDetailObject.recipientUserIDs))
            newFormData.append('sharedDate', UPSIDetailObject.sharedDate)
            newFormData.append('sharedTime', UPSIDetailObject.sharedTime)
            newFormData.append('sharerType', UPSIDetailObject.sharerType)
            newFormData.append('typeOfShared', UPSIDetailObject.typeOfShared)
            newFormData.append('possessionOfUPSI', UPSIDetailObject.possessionOfUPSI)
            newFormData.append('purposeForSharing', UPSIDetailObject.purposeForSharing)
            newFormData.append('modeOfSharing', UPSIDetailObject.modeOfSharing)
            newFormData.append('DateOfInitiation', UPSIDetailObject.DateOfInitiation)
            newFormData.append('EmailText', UPSIDetailObject.EmailText)
            newFormData.append('EmailSubject', UPSIDetailObject.EmailSubject)
            newFormData.append('NatureofUPSI', UPSIDetailObject.NatureofUPSI)
            newFormData.append('NatureText', UPSIDetailObject.NatureText)
            newFormData.append('OtherNatureOfUPSI', UPSIDetailObject.OtherNatureOfUPSI)
            newFormData.append('PublicStatus', UPSIDetailObject.PublicStatus)
            newFormData.append('IPAddress', UPSIDetailObject.IPAddress)

            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
              if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                  console.log('it is here')
                  console.log(JSON.parse(xhr.response));
                  self.alert.successWithOk('UPSI Detail is added successfully.', 'userMaster/upsidetails')
                  return;
                } else {
                  console.log(xhr.response);
                  self.alert.error(xhr.response);
                  return;
                }
              }
            }
            xhr.open("POST", environment.pssServerUrl + "upsidetails/update/" + this.UPSIDetailsId, true);
            var token = localStorage.getItem('token')
            xhr.setRequestHeader('x-access-token', token)
            xhr.setRequestHeader('userdetail', this.getUserDetail())
            xhr.setRequestHeader('pssdetail', localStorage.getItem("companyDetails"))
            xhr.send(newFormData);
          } else {
            this.alert.error(JSON.stringify(response.err_fields) + ' fields are required or invalid.')
          }
        })

      } else {
        let updateService = !this.isBulkData ? this.upsiDatailsService.updateUPSI : this.upsiDatailsService.updateBulkUPSI
        updateService = updateService.bind(this.upsiDatailsService)
        updateService(this.UPSIDetailsId, UPSIDetailObject).subscribe((response:any) => {
          this.loading = false;
          this.disabledOnclick = false;
          if (!response.status) {
            // let message = !this.isBulkData ? 'UPSI Detail is added successfully.' : 'UPSI Detail is updated successfully.';
            // let route = !this.isBulkData ? 'userMaster/upsidetails' : "upsibulkdata"
            // console.log('route',message,route)

            // let route = !this.isBulkData ?[{ outlets: { 'structure-outlet': ['userMaster', route] } }]
            if(this.isBulkData){
            self.alert.successWithOk('UPSI Detail is updated successfully.', 'userMaster/upsibulkdata')
            }else{
            self.alert.successWithOk('UPSI Detail is updated successfully.', 'userMaster/upsidetails')
            }
          } else {
            this.alert.error(JSON.stringify(response.err_fields) + ' fields are required or invalid.')
          }
        })
      }

    } else {
      this.isValidSharerAndRecipient = true;
    }
  }

  downloadFile(id) {
    var token = localStorage.getItem('token')
    window.location.href = this.downloadURLForUPSI + id + '/' + token;
  }

  deleteFile(id) {
    console.log(id)
    this.documentId = null;
    this.isFileDeleted = true;
  }


  getUserDetail() {
    var user = JSON.parse(localStorage.getItem("user"));
    var resources = JSON.parse(localStorage.getItem("resources"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));
    var resourcesData = resources.filter(function (item) {
      return item.Menu === 'UPSI';
    })[0]

    var upsiAdmin;
    if (resourcesData) {
      upsiAdmin = (resourcesData['Menu']) ? true : false
    } else {
      upsiAdmin = false
    }
    var decrEmailId = this.commonFunction.decrypt(user.EmailId);
    var loginUser = {
      id: user._id,
      firstName: user.FirstName,
      lastName: user.LastName,
      upsiAdmin: upsiAdmin,
      // EmailId: user.EmailId,
      EmailId: decrEmailId,
      companyDetails: companyDetails,
      title: user.Title
    }
    return JSON.stringify(loginUser);
  }

  fileChangedEmail($event) {
    // console.log('file changed', $event.target.files[0])
    // this.filesToUploadEmail = $event.target.files[0];
    // console.log("this.filesToUploadEmail", this.filesToUploadEmail)

    var checkfile = this.commonFunction.checkFileExtension($event);
    if (checkfile) {
      this.filesToUploadEmail = $event.target.files[0];
      this.fileExtension = true;
    } else {
      this.fileExtension = false;
    }
    console.log("fileExtension", this.fileExtension);

  }
  deleteFileEmail() {

    this.DocumentFileDoc = false;
    this.isFileDeletedEmail = true;
    this.filesToUploadEmail = false;
  }

  downloadFileEmail(fileName) {

    var token = localStorage.getItem('token')

    console.log('downloadURLForUPSIEmail', this.downloadURLForUPSIEmail + this.DocumentFileDoc)
    window.location.href = this.downloadURLForUPSIEmail + fileName + '/' + token;
  }

  downloadFileBase(fileName) {
    var token = localStorage.getItem('token')
    console.log('downloadURLForUPSIBase', this.downloadURLForUPSIBase)
    window.location.href = this.downloadURLForUPSIBase + fileName + '/' + token;
  }
  
  deleteFileBase(index) {
    var fileNametoBeRemoved = this.basefileNameArray[index].name;
    this.basefileNameArray.splice(index,1);     //removing file from the array that just stors names
    if(this.isEdit){
      for(var x=0;x<this.basefileArrayUpdate.length;x++){
        if(this.basefileArrayUpdate[x].name == fileNametoBeRemoved){
          this.basefileArrayUpdate.splice(x,1);
          break;
        }
      }
    }else{
      for(var x=0;x<this.basefileArray.length;x++){            // break was used so fileNametoBeRemoved is only removed once incase same files are uploaded
        if(this.basefileArray[x].name == fileNametoBeRemoved){
          this.basefileArray.splice(x,1);
          break;
        }
      }
    }
  }
  
  makeFileRequestEmail(url: string, params: any, files, title: string) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var self = this;
      var xhr = new XMLHttpRequest();
      console.log('files', files)
      for (var i = 0; i < files.length; i++) {
        formData.append("file", files[i], params + "-" + files[i].name.replace(',', ''));
      }
      xhr.onreadystatechange = function () {
        console.log("xhr", xhr)
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(xhr.response);
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.setRequestHeader('userdetail', this.getUserDetail())
      xhr.setRequestHeader('pssdetail', localStorage.getItem("companyDetails"))
      xhr.send(formData);
    });
  }

  EmailsCheckOniN() {
    if (_.size(this.sharerForm.value.EmailSubject) || _.size(this.sharerForm.value.EmailText) || (this.filesToUploadEmail && _.size(this.filesToUploadEmail.name))) {
      $('.IsDisable').prop("disabled", true);
      $('.IsDisable').css("display", 'none');
      this.textMsg = true;
    } else {
      $('.IsDisable').prop("disabled", false);
      $('.IsDisable').css("display", 'flex');
      this.textMsg = false;
    }

  }

  EmailsCheck($event) {



    if (_.size(this.sharerForm.value.EmailSubject) || _.size(this.sharerForm.value.EmailText) || (this.filesToUploadEmail && _.size(this.filesToUploadEmail.name))) {
      $('.IsDisable').prop("disabled", true);
      $('.IsDisable').css("display", 'none');
      var sharedDateObject = { year: new Date().getFullYear(), day: new Date().getDate(), month: new Date().getMonth() + 1 }
      this.sharerForm.controls.sharedDate.setValue(sharedDateObject);
      var sharerTime = new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
      this.sharerForm.controls.sharedTime.setValue(sharerTime);
      this.sharerForm.controls.modeOfSharing.setValue('Email through DigiCompany UPSI Software')
      this.textMsg = true;
    } else {
      $('.IsDisable').prop("disabled", false);
      $('.IsDisable').css("display", 'flex');
      this.sharerForm.controls.sharedDate.setValue(null);
      this.sharerForm.controls.sharedTime.setValue(null);
      this.sharerForm.controls.modeOfSharing.setValue(null);
      this.textMsg = false;
    }
  }

  addModel() {
    this.item = null
    $("#AddModel").modal('show');
  }

  save() {
    this.disabledOnclick = true;
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var paramData = {
      companyID: companyDetails.companyID
    }
    if (_.size(this.item)) {
      this.disabledText = false;
      this.upsiMasterService.addItem({ 'item': this.item }).subscribe((response:any) => {
        this.disabledOnclick = false;
        if (response.status == 0) {
          this.alert.success(response.message);
          this.OtherNatureOfUPSIValid = false
        } else {
          this.alert.error('Nature of UPSI already exists.');
        }
        $("#AddModel").modal('hide');
        console.log("test", response)
        this.viewtagList(this.paramData);
        this.sharerForm.controls.NatureofUPSI.setValue(response.data._id);
      })
    } else {
      this.disabledText = true;
    }
  }

  viewtagList(paramData) {
    this.upsiMasterService.getList(paramData).subscribe((response:any) => {
      if (response.status == 0) {
        this.ItemList = response.data;
      }
    })
  }

  changeNature() {
    if (this.sharerForm.value.NatureofUPSI == "Other") {
      this.othernature = true;
      this.OtherNatureOfUPSI = this.sharerForm.value.OtherNatureOfUPSI
      console.log('_.size(this.OtherNatureOfUPSI)', _.size(this.OtherNatureOfUPSI))
      if (_.size(this.OtherNatureOfUPSI)) {
        this.OtherNatureOfUPSIValid = false
      } else {
        this.OtherNatureOfUPSIValid = true
      }
    } else {
      this.othernature = false;
      this.OtherNatureOfUPSIValid = false
    }
  }

  othernaturemethod() {
    this.OtherNatureOfUPSI = this.sharerForm.value.OtherNatureOfUPSI
    console.log('_.size(this.OtherNatureOfUPSI)', _.size(this.OtherNatureOfUPSI))
    if (_.size(this.OtherNatureOfUPSI)) {
      this.OtherNatureOfUPSIValid = false
    } else {
      if (this.sharerForm.value.NatureofUPSI == "Other") {
        this.OtherNatureOfUPSIValid = true
      } else {
        this.OtherNatureOfUPSIValid = false
      }
    }
  }
  setPublicDate($event) {
    console.log(" setPublicDate event", $event)
    console.log("setPublicDate this.sharerForm", this.sharerForm)

    if(!this.isBulkData && this.EmailWithAttachment && this.EmailUpsiAdd){ // straight away return if Email Enabled
      console.log("return if Email Enabled");
      return ;
    }
    this.sharerdateForPublic = { year: $event.year, month: $event.month, day: $event.day }

    // Removed date/time restrictions - allow past, current, and future dates/times
    // No validation needed - user can select any date and time

    
    

  }

  setPublicDatePublic($event) {
    console.log("this.sharerForm.value.sharedDate", this.sharerForm.value.sharedDate)
    this.sharerdateForPublic = this.sharerForm.value.sharedDate
  }

  // Debug method to check form validity
  checkFormValidity() {
    console.log('=== UPSI Form Validation Debug ===');
    console.log('Form Valid:', this.sharerForm.valid);
    console.log('RecipientNameArray:', this.RecipientNameArray);
    console.log('RecipientNameArray length:', this.RecipientNameArray?.length);
    console.log('OtherNatureOfUPSIValid:', this.OtherNatureOfUPSIValid);
    console.log('disabledOnclick:', this.disabledOnclick);
    console.log('NatureofUPSI value:', this.sharerForm.value.NatureofUPSI);
    console.log('OtherNatureOfUPSI value:', this.sharerForm.value.OtherNatureOfUPSI);
    
    console.log('\n--- Invalid Form Controls ---');
    Object.keys(this.sharerForm.controls).forEach(key => {
      const control = this.sharerForm.get(key);
      if (control && control.invalid) {
        console.log(`❌ ${key}:`, control.errors, 'Value:', control.value);
      }
    });
    
    console.log('\n--- Button Disabled Reasons ---');
    if (!this.RecipientNameArray || this.RecipientNameArray.length === 0) {
      console.log('❌ No recipients selected');
    }
    if (!this.sharerForm.valid) {
      console.log('❌ Form is invalid');
    }
    if (this.OtherNatureOfUPSIValid) {
      console.log('❌ OtherNatureOfUPSI validation failed');
    }
    if (this.disabledOnclick) {
      console.log('❌ Button is disabled by disabledOnclick flag');
    }
    
    console.log('=================================');
  }
}
